import React from "react";
import CarouselTermsLoop from "../CarouselTermsLoop";
import Link from "next/link";
import { SubCategoryType } from "~/lib/db/multimedia";

const mockSubcategories: SubCategoryType[] = [
  {
    term_id: 1n,
    name: "Scenari",
    slug: "scenari",
    description: "",
    img: "https://wp-bs.buddismoesocieta.org/site/wp-content/uploads/2026/06/bs_articoli_podcast.jpg",
  },
];
export const PodcastCarouselLayout = ({ subcategoryToShow }) => {
  return <CarouselTermsLoop carouselTermsLoop={subcategoryToShow} />;
};

export default PodcastCarouselLayout;
